import React from 'react'
import MyListBlock from '../../../UI/list/MyListBlock'
import { useState } from 'react'
import { useEffect } from 'react'

const PackingConfirmResult = ({ resultData }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListData()
    }, [resultData])

    const setListData = () => {
        const listTemp = []

        if (resultData) {
            if (resultData.pack) {
                listTemp.push({
                    name: 'Партія',
                    value: resultData.pack.seriesText
                })
            }
            if (resultData.box) {
                listTemp.push({
                    name: 'Велика коробка з 10шт №',
                    value: resultData.box.number
                })
            }

            if(resultData.serieses && resultData.serieses.length > 0) {
                for (const series of resultData.serieses) {
                    let name = series.goodType ? series.goodType.name + ' ' : '' 
                    name += series.good ? series.good.name + ' ' : '' 

                    const seriesText = series.seriesText ? series.seriesText : series.anotherSeries
                    listTemp.push({
                        name: name,
                        value: seriesText
                    })
                }
            }

            listTemp.push({
                name: 'Пропи (пропейлери)',
                value: 'без серії'
            })

            setList(listTemp)
        } else {
            setList(listTemp)
        }
    }

  return (
    <div>
        <MyListBlock 
            text={'Перевірка даних, що отримані в результаті зчитування'}
            list={list}
        />
    </div>
  )
}

export default PackingConfirmResult